<template>
  <div class="app-root">
    <div
      v-if="!$route.meta.hideMenu"
      class="app-layout"
      :class="{ hideSidebar: sidebarCollapsed }"
    >
      <aside class="sidebar-container" data-tour="aside-menu">
        <Aside />
      </aside>
      <div class="main-container">
        <div class="navbar">
          <AppHeader />
        </div>
        <TagsView />
        <div class="appContent" data-tour="main-content">
          <router-view />
        </div>
      </div>
      <Guide v-if="isNotLogin"></Guide>
      <SpotlightTour v-if="isNotLogin" ref="spotlightTour" />
      <div v-loading.fullscreen.lock="isLoadingShow"></div>
    </div>
    <div v-else class="allScreen">
      <router-view />
      <SpotlightTour v-if="isNotLogin" ref="spotlightTour" />
      <div v-loading.fullscreen.lock="isLoadingShow"></div>
    </div>
  </div>
</template>

<script>
import Aside from "@/components/Aside";
import AppHeader from "@/components/AppHeader";
import TagsView from "@/components/TagsView";
import Guide from "@/components/Guide";
import SpotlightTour from "@/components/SpotlightTour";
import eventBus from "@/utils/eventBus";
import { isTourFinished } from "@/constants/onboardingTour";
import { mapGetters, mapState } from "vuex";

export default {
  watch: {
    isNotLogin: {
      immediate: true,
      handler(val) {
        if (val && !this.$route.meta.hideMenu) {
          this.tryAutoStartTour();
        }
      },
    },
    $route(to) {
      if (this.isNotLogin && !to.meta.hideMenu) {
        this.tryAutoStartTour();
      }
    },
  },
  methods: {
    tryAutoStartTour() {
      if (isTourFinished()) return;
      if (this._tourAutoStarted) return;
      this._tourAutoStarted = true;
      this.$nextTick(() => {
        setTimeout(() => eventBus.$emit("startSpotlightTour"), 600);
      });
    },
  },
  computed: {
    ...mapGetters({
      isLoadingShow: "getShowLoadingState",
    }),
    ...mapState(["sidebarCollapsed"]),
    isNotLogin() {
      const path = this.$route.path;
      const isLogin = path === "/" || path === "/login" || path === "/register" || path === "/personal";
      return !isLogin;
    },
  },
  components: {
    Aside,
    AppHeader,
    TagsView,
    Guide,
    SpotlightTour,
  },
};
</script>
<style>
body {
  height: 100% !important;
  width: 100% !important;
}
html {
  width: 100%;
  height: 100%;
}
#app {
  font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC",
    "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
.app-root {
  height: 100%;
  width: 100%;
}
.app-layout {
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
  text-align: left;
}
.sidebar-container {
  width: 210px;
  height: 100%;
  background: #fff;
  border-right: 1px solid #e8e8e8;
  transition: width 0.28s;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 1001;
}
.hideSidebar .sidebar-container {
  width: 64px;
}
.main-container {
  flex: 1;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.navbar {
  height: 50px;
  flex-shrink: 0;
  overflow: hidden;
}
.appContent {
  flex: 1;
  min-height: 0;
  background-color: rgb(245, 247, 250);
  overflow: auto;
}
.allScreen {
  height: 100%;
  width: 100%;
}
.el-header {
  padding: 0 !important;
}
.el-button--text.delete-text-btn {
  color: #f56c6c;
}
.table-ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background: transparent;
}
::-webkit-scrollbar-track {
  border-radius: 4px;
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #c0c0c0;
}
</style>
